import { Component, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { ProcessesQueryString } from '../../models/processesQueryString';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { Status } from '../../shared/enums/status';

@Component({
  selector: 'hub-search-form',
  standalone: true,
  imports: [
    ButtonModule,
    CalendarModule,
    DropdownModule,
    InputTextModule,
    ReactiveFormsModule,
    ToastModule,
    TooltipModule,
  ],
  providers: [MessageService],
  templateUrl: './search-form.component.html',
  styleUrl: './search-form.component.scss',
})
export class SearchFormComponent implements OnInit {
  @Output() filterEmitter = new EventEmitter<ProcessesQueryString>();
  private messageService = inject(MessageService);

  public statusOptions = [
    { name: Status[Status.Pendente], id: Status.Pendente },
    { name: Status[Status.Processamento], id: Status.Processamento },
    { name: Status[Status.Finalizado], id: Status.Finalizado },
    { name: Status[Status['Finalizado com erro']], id: Status['Finalizado com erro'] },
  ];

  public searchForm = new FormGroup({
    endDateSearchControl: new FormControl(),
    idSearchControl: new FormControl(),
    nameSearchControl: new FormControl(),
    startDateSearchControl: new FormControl(),
    statusSearchControl: new FormControl(),
  });

  minDate = new Date(0);

  ngOnInit(): void {
    const filters = JSON.parse(sessionStorage.getItem('hubapi-web-process') ?? '{}');

    Object.keys(filters).forEach(key => {
      const control: any = this.searchForm.get(`${key}SearchControl`);
      if (control && filters[key]) {
        if (key === 'status') {
          setTimeout(() => control.setValue(filters[key]), 50);
        } else if (key === 'startDate' || key === 'endDate') {
          control.setValue(this.toDate(filters[key]));
        } else {
          control.setValue(filters[key]);
        }
      }
    });
  }

  private isGuid(value: string): boolean {
    const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return guidRegex.test(value);
  }

  public search(): void {
    const { idSearchControl } = this.searchForm.value;
    let id = null;

    if (idSearchControl) {
      if (this.isGuid(idSearchControl)) {
        id = idSearchControl;
      } else {
        this.messageService.add({ severity: 'warn', summary: 'Atenção!', detail: 'Insira um id válido' });
        return;
      }
    }

    this.filterEmitter.emit({
      index: 0,
      size: 10,
      endDate: this.searchForm.controls['endDateSearchControl'].value,
      id: id,
      name: this.searchForm.controls['nameSearchControl'].value,
      startDate: this.searchForm.controls['startDateSearchControl'].value,
      status: this.searchForm.controls['statusSearchControl'].value,
    });
  }

  public clearFilters(): void {
    this.searchForm.reset({
      endDateSearchControl: null,
      idSearchControl: '',
      nameSearchControl: '',
      startDateSearchControl: null,
      statusSearchControl: null,
    });

    this.search();
  }

  private toDate(dateString: string): Date {
    const parts = dateString.split('T')[0].split('-'); // Dividir a string em partes e pegar apenas a parte da data
    const year = parseInt(parts[0]);
    const month = parseInt(parts[1]) - 1; // Os meses em JavaScript são baseados em zero
    const day = parseInt(parts[2]);

    return new Date(year, month, day);
  }
}
